"use client";

import Skeleton from "react-loading-skeleton";
import Price from "@/components/Price/price";
import { BodyText } from "@/components/BodyText";
import Badge from "@/components/Badge";
import ProductAttributes from "./product-attributes";
// import ProductCartBuyInquiry from "@/components/Product/product-cart-buy-inquiry";
import { defaultLocale } from "@/config.ts";

import { Link } from "@/navigation";
// import ProductVariable from "@/components/Product/product-variable";
// import { useProductVariableStore } from "@/lib/store/product-variable.store";
// import { useProductAttributeStore } from "@/lib/store/product-attribute.store";
import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import ProductCartBuyInquiry from "./product-cart-buy-inquiry";
import Server from "./Server";

import ProductInfo from "./ProductInfo";

type Props = {
	product: any | null;
	locale: string;
};

export default function Information({ product, locale }: Props) {
	let [VariantActive, setVariantActive] = useState<any>(null);
	let [Variant, setVariant] = useState<any>(product.variants[0]);
	const [isExtraCollapsed, setIsExtraCollapsed] = useState(true);

	const t = useTranslations();
	// const { setSelectAttribute } = useProductAttributeStore();
	const handlerAttribute = (item: any) => {
		setVariantActive(item);
		setVariant(item);
		// console.log("this is  VariantActive", VariantActive);
	};
	// const { currentProduct } = useProductVariableStore();

	let isvariants = product.variants.some((item) => item.quantityAvailable > 0);
	let [description] = useState<any>(JSON.parse(product.description));
	const descriptionJson: any = product?.translation?.descriptionJson
		? JSON.parse(product?.translation?.descriptionJson)
		: null;

	useEffect(() => {
		// console.log("this is product", product);
	}, [product]);

	useEffect(() => {
		const handleFloatingStart = () => {
			setIsExtraCollapsed(true);
		};
		window.addEventListener("product-info-floating-start", handleFloatingStart);
		return () => {
			window.removeEventListener("product-info-floating-start", handleFloatingStart);
		};
	}, []);

	const productName =
		product.name && locale === defaultLocale
			? product.name
			: product.translation
				? product.translation.name
				: product.name;

	return (
		<div className="relative flex-1">
			<div id="product-select">
				<div id="product-select-top"></div>
				{product?.name ? (
					<h1
						className="font-display line-clamp-3 text-[clamp(1.25rem,2vw,1.75rem)] leading-[1.25] tracking-[-0.01em] text-themeSecondary800"
						title={productName}
					>
						{productName}
					</h1>
				) : (
					<>
						<Skeleton width={"100%"} height={32} />
						<Skeleton width={"80%"} height={32} />
					</>
				)}
				{process.env.NEXT_PUBLIC_SITE_TYPE == "toc" && (
					<div className="mt-3 flex flex-col flex-wrap items-start justify-center gap-2 py-3">
						<div className="c-flex gap-2">
							{product ? (
								<Badge className={`${!!isvariants ? "" : ""}`}>
									{isvariants ? t("nav.IN STOCK") : t("nav.OUT OF STOCK")}
								</Badge>
							) : (
								<Skeleton width={100} height={30} />
							)}
						</div>
						<div className="c-flex">
							{product ? (
								<>
									<Price
										price={Variant?.pricing?.price.gross.amount || ""}
										currency={Variant?.pricing?.price.gross.currency}
										className="text-[20px]"
									/>

									{/* <div className="hidden h-8 w-0.5 bg-themeSecondary200 md:block"></div> */}
									{/* <Price price={product.pricing.priceRange?.start.gross.amount} className="text-[22px]  " />
									<div
										className={`${
											product.pricing.priceRange?.start.gross.amount ===
											product.pricing.priceRange?.stop.gross.amount
												? "hidden"
												: ""
										}`}
									>
										<span className="mx-1">–</span>
										<Price price={product.pricing.priceRange?.stop.gross.amount} className="text-[22px]" />
									</div> */}
								</>
							) : (
								<Skeleton width={120} height={30} />
							)}
						</div>
						{/* <div className="c-flex gap-2">
							{product ? (
								<>
									<BodyText>
										<Rating
											readonly
											//  @ts-ignore
											initialRating={product.rating > 5 ? 5 : product.rating || 5}
											emptySymbol={<i className="ri-star-fill text-themeSecondary300 max-md:text-sm" />}
											fullSymbol={<i className="ri-star-fill text-themeWarning500 max-md:text-sm" />}
										/>
										<span className="px-0.5 text-xs font-normal  text-themeSecondary800 sm:text-sm">
											{product?.averageRating}
										</span>
									</BodyText>
									评分
									<BodyText className="text-xs font-normal text-themeSecondary800 sm:text-sm">
										{product?.reviewCount || 0} {t("product.reviews")}
									</BodyText>
									review
								</>
							) : (
								<Skeleton width={120} height={30} />
							)}
						</div> */}
					</div>
				)}

				<div className="proSel-options mt-4">
					{product
						? description?.blocks[1]?.data?.text &&
							descriptionJson?.blocks[1]?.data?.text && (
								<>
									<BodyText
										innerHTML={
											locale === defaultLocale
												? description?.blocks[1]?.data?.text
												: descriptionJson?.blocks[1]?.data?.text || ""
										}
										className="font-body text-brand-muted line-clamp-4 !text-[14px] font-normal !leading-[23px]"
									></BodyText>
								</>
							)
						: [0, 1, 2].map((i) => {
								return <Skeleton width={"100%"} height={30} className="mt-2" key={i} />;
							})}

					{product?.variants.length && (
						<ProductAttributes options={product?.variants} changeValue={handlerAttribute} />
					)}

					{/* {Variant?.pricing?.price.gross.amount && (
						<BodyText className="mt-3 text-base font-normal text-main">
							{Variant?.pricing?.price.gross.currency}:{Variant?.pricing?.price.gross.amount}
						</BodyText>
					)} */}
				</div>

				{/* 添加 */}
				<ProductCartBuyInquiry {...product} product={product} VariantActive={VariantActive} />

				<div className="mt-3 flex items-center justify-end">
					<button
						type="button"
						onClick={() => setIsExtraCollapsed((prev) => !prev)}
						className="font-body text-brand-fg text-xs font-semibold uppercase tracking-[0.12em] transition-opacity hover:opacity-80"
					>
						{isExtraCollapsed ? t("common.VIEW_MORE") : t("common.VIEW_LESS")}
					</button>
				</div>

				{/* 商品的属性 */}
				{/* <ProductInfo product={product} /> */}

				{/* <div className="mt-4 flex flex-col gap-4">
					<div className="s-flex my-2 flex-wrap">
						{t("common.Category")}:{product.category.name}
					</div>
					<SocialShare />
				</div> */}
				<div
					className={
						isExtraCollapsed
							? "max-h-0 overflow-hidden opacity-0 transition-all duration-300"
							: "max-h-[400px] opacity-100 transition-all duration-300"
					}
				>
					<Server></Server>
				</div>
			</div>
		</div>
	);
}
